<template>
  <label
    :class="`ds-textfield ds-textfield--${inputClass} ${size} ? ds-textfield--${size} : ''`"
  >
    <input
      v-bind="$attrs"
      :id="id"
      v-model="localValue"
      :type="!isPassword? type : localType"
      :name="name"
      :required="required"
      :maxlength="counter ? maxCharacter : ''"
      :disabled="disabled"
      ds-component="DsTextField"
      data-testid="ds-textfield"
      placeholder=" "
      v-on="{
        ...$listeners,
        input: (event) => $emit('input', event.target.value)
      }"
    />
    <span>{{ label }} {{ required ? ' *' : '' }}</span>
    <div
      v-if="isPassword"
      class="ds-textfield__password-icon"
      @click="toggleVisibility()"
    >
      <DsIcon
        :name="showPassword ? 'hide' : 'view'"
        size="small"
      />
    </div>

    <small
      v-if="helpText"
      data-testid="ds-textfield-help"
      class="ds-textfield--help-text"
      >{{ helpText }}</small
    >
    <small
      v-if="requiredText"
      data-testid="ds-textfield-required"
      class="ds-textfield--required-text"
      >{{ requiredText }}</small
    >
    <small
      v-if="counter"
      data-testid="ds-textfield-counter"
      class="ds-textfield--counter"
      >{{ totalCharacter }}/{{ maxCharacter }}</small
    >
  </label>
</template>

<script lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from 'vue';
import { DsIcon } from '@ds/icons';

export default Vue.extend({
  name: 'DsTextField',
  components: {
    DsIcon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    helpText: {
      type: String,
      required: false
    },
    inputClass: {
      type: String,
      required: false,
      default: 'default'
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    },
    counter: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    requiredText: {
      type: String,
      required: false
    },
    maxCharacter: {
      type: Number,
      required: false
    },
    size: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      showPassword: false,
      localValue: ''
    };
  },
  computed: {
    totalCharacter() {
      return this.value.length;
    },
    isPassword() {
      return this.type === 'password';
    },
    localType() {
      return this.showPassword ? 'text' : 'password';
    }
  },
  mounted() {
    this.localValue = this.value;
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  },
  methods: {
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/TextField.scss';
</style>
